{
  "WHATSAPP_TEMPLATES": {
    "MODAL": {
      "TITLE": "Modèles WhatsApp",
      "SUBTITLE": "Sélectionnez le modèle whatsapp que vous souhaitez envoyer",
      "TEMPLATE_SELECTED_SUBTITLE": "Configure template: {templateName}"
    },
    "PICKER": {
      "SEARCH_PLACEHOLDER": "Rechercher des modèles",
      "NO_TEMPLATES_FOUND": "Aucun modèle trouvé pour",
      "HEADER": "Header",
      "BODY": "Body",
      "FOOTER": "Footer",
      "BUTTONS": "Buttons",
      "CATEGORY": "Catégorie",
      "MEDIA_CONTENT": "Media Content",
      "MEDIA_CONTENT_FALLBACK": "media content",
      "NO_TEMPLATES_AVAILABLE": "No WhatsApp templates available. Click refresh to sync templates from WhatsApp.",
      "REFRESH_BUTTON": "Refresh templates",
      "REFRESH_SUCCESS": "Templates refresh initiated. It may take a couple of minutes to update.",
      "REFRESH_ERROR": "Failed to refresh templates. Please try again.",
      "LABELS": {
        "LANGUAGE": "Langue",
        "TEMPLATE_BODY": "Corps du modèle",
        "CATEGORY": "Catégorie"
      }
    },
    "PARSER": {
      "VARIABLES_LABEL": "Variables",
      "LANGUAGE": "Langue",
      "CATEGORY": "Catégorie",
      "VARIABLE_PLACEHOLDER": "Entrez la valeur de {variable}",
      "GO_BACK_LABEL": "Retour",
      "SEND_MESSAGE_LABEL": "Envoyer un message",
      "FORM_ERROR_MESSAGE": "Veuillez remplir toutes les variables avant d'envoyer",
      "MEDIA_HEADER_LABEL": "{type} Header",
      "OTP_CODE": "Enter 4-8 digit OTP",
      "EXPIRY_MINUTES": "Enter expiry minutes",
      "BUTTON_PARAMETERS": "Button Parameters",
      "BUTTON_LABEL": "Button {index}",
      "COUPON_CODE": "Enter coupon code (max 15 chars)",
      "MEDIA_URL_LABEL": "Enter {type} URL",
      "DOCUMENT_NAME_PLACEHOLDER": "Enter document filename (e.g., Invoice_2025.pdf)",
      "BUTTON_PARAMETER": "Enter button parameter"
    }
  }
}
